<template>
  <div>
    <common-dialog ref="dialog" width="1100px" line-form unit="收入单" edit-title id-key="DocId" :data="data"
      :get-data-func="api.info" form-label-width="95px" @create-opened="onCreateOpened" @edit-opened="onEditOpened"
      @opened="onOpened" :form-rules="rules" @closed="onClosed">
      <template slot="form">
        <el-row class="border">
          <el-row>
            <el-col :span="isMB ? 24 : 6">
              <el-form-item label="收入单编号" prop="DocNo">
                <span v-if="Mode == 0" class="detail-span">{{ data.DocNo }}</span>
                <el-input v-else v-model="data.DocNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="isMB ? 24 : 6">
              <el-form-item label="单据日期" prop="DocDate">
                <el-date-picker v-model="data.DocDate" placeholder="请选择日期" value-format="yyyy-MM-dd" :editable="false">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="isMB ? 24 : 6">
              <el-form-item label="往来单位" prop="TradeUnitId" :rules="data.NeedTradeUnit ? tu : null">
                <select-input placeholder="请选择单位" :label="data.TradeUnitName" v-model="data.TradeUnitId"
                  @click="openTradeunit" />
              </el-form-item>
            </el-col>
            <el-col :span="isMB ? 24 : 6">
              <el-form-item label="票据类型" prop="InvoiceTypeId">
                <invoice-select v-model="data.InvoiceTypeId" @change="invoiceChange" :clearable="false" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="isMB ? 24 : 6">
              <el-form-item label="业务类型" prop="BusinessTypeId">
                <business-select v-model="data.BusinessTypeId" :params="{ Kind: '应收', SourceType: '收入单' }"
                  @change="onChange" />
              </el-form-item>
            </el-col>
            <el-col :span="isMB ? 24 : 6">
              <el-form-item label="经办人" prop="ClerkId">
                <select-input placeholder="请选择经办人" :label="data.ClerkName" v-model="data.ClerkId" @click="openEmp" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="备注" prop="Remark">
                <el-input type="textarea" v-model="data.Remark" placeholder="请输入备注"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
        <template v-if="data.InvoiceTypeId != null">
          <edit-list2 v-if="data.InvoiceTypeName == '收据'" ref="editList" />
          <edit-list1 v-else ref="editList" />
        </template>
        <div class="row-tb-head" style="margin-top: 10px;">
          <span>收款信息</span>
          <div style="float: right;">
            <el-button type="primary" icon="el-icon-plus" @click="addReceipt">添加</el-button>
          </div>
        </div>
        <el-table border class="table-line tb-c-head" :data="data.RpIncomeDocReceiptDtos">
          <el-table-column prop="SettleName" label="结算方式" min-width="110">
            <template slot-scope="{row}">
              <el-select v-model="row.SettleId" @change="setSettle(row)" placeholder="请选择结算方式">
                <template v-for="(i, key) in Settles">
                  <el-option :key="key" :label="i.SettleName" :value="i.SettleId"></el-option>
                </template>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="AccountName" label="收款账号">
            <template slot-scope="{row}">
              <select-input placeholder="请选择账号" :label="row.AccountName" v-model="row.AccountId"
                @click="openAccount(row)" />
            </template>
          </el-table-column>
          <el-table-column prop="ReceiptAmount" label="收款金额">
            <template slot-scope="{row}">
              <el-input v-model="row.ReceiptAmount" @input="onInput(row)" placeholder="请输入收款金额"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="95" fixed="right">
            <template slot-scope="{row,$index}">
              <!-- <el-link style="margin-right:10px" @click="copyRow(row,$index)" :underline="false">复制</el-link> -->
              <el-link @click="delReceipt(row, $index)" :underline="false">删除</el-link>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <template slot="footer" slot-scope="{isLoading}">
        <!-- <el-button type="success" :loading="isLoading" @click="save('submit')">提 交</el-button> -->
        <el-button type="primary" :loading="isLoading" @click="save('save')">保 存</el-button>
        <el-button @click="close">关 闭</el-button>
      </template>

      <!-- 后面补充 -->
      <!-- <account-dialog ref="accountDialog" in-dialog selectable @select="setAccount" /> -->
      <tradeunit-dialog ref="tradeunitDialog" in-dialog selectable @select="setTradeunit" />
      <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" />
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
// import accountDialog from "@/components/basedoc/account/listDialog";
import businessSelect from "@/components/basedata/basedoc/business/select";
import invoiceSelect from "@/components/basedata/basedoc/billtype/select";
import tradeunitDialog from "@/components/basedata/business/come/listDialog";
import empDialog from "@/components/personnel/result/record/listDialog";
import editList1 from "./editList1";
import editList2 from "./editList2";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    // accountDialog,
    businessSelect,
    invoiceSelect,
    tradeunitDialog,
    empDialog,
    editList1,
    editList2,
  },
  data() {
    return {
      api: require("@/api/rp/incomeDoc").default,
      code_api: require("@/api/sy/serialCode").default,
      settle_api: require("@/api/ba/settle").default,
      income_api: require("@/api/ba/income").default,

      data: {
        DocId: 0,
        DocNo: "", //编号
        DocDate: this.$commonJs.getToday(), //单据日期
        TradeUnitId: null, //往来单位Id
        TradeUnitName: "",
        UnitType: 0, //类型 - 1:零售 2:批发 3:供应商
        // DocType: null,
        SourceDocId: null,
        SourceDocNo: "",
        SourceBillName: "",
        BusinessTypeId: null, //业务类型
        InvoiceTypeId: null, //票据类型 - 0:不开票 SY_InvoiceType
        InvoiceTypeName: "",
        ClerkId: null, //经办人
        ClerkName: "",
        Amount: null, //金额
        TaxAmount: null, //税额
        IncTaxAmount: null, //含税金额
        NoTaxAmount: null, //无税金额
        ReceiptAmount: null, //收款税额
        RemainAmount: null, //剩余金额
        Remark: "", //备注
        NeedTradeUnit: true,

        RpIncomeDocDtsDtos: [],
        RpIncomeDocReceiptDtos: [],
      },
      Mode: 0,
      DelRpIncomeDocReceiptDtos: [],
      current: null,
      Settles: [], //结算方式列表
      Income: [], //收入
      isMB: this.$store.state.isMB,
      rules: {
        DocNo: [{ required: true, message: "收入单编号不能为空" }],
        DocDate: [{ required: true, message: "单据日期不能为空" }],
        ClerkId: [{ required: true, message: "请选择经办人" }],
        BusinessTypeId: [{ required: true, message: "请选择业务类型" }],
        InvoiceTypeId: [{ required: true, message: "请选择票据类型" }],
      },
      tu: [{ required: true, message: "请选择单位" }],
    };
  },
  methods: {
    onCreateOpened() {
      var user = this.$store.state.user;
      // console.log("user", JSON.parse(JSON.stringify(user)));
      if (user) {
        
        this.data.ClerkId = user.empId;
        this.data.ClerkName = user.name;
      }
      this.code_api.previewNo("收入单").then((res) => {
        // console.log("serialType", res);
        if (res.Code == 0) {
          this.Mode = res.Data.Mode;
          this.data.DocNo = res.Data.PreviewNo;
        } else {
          this.$message.warning("获取收入单编号失败");
        }
      });
      // this.addReceipt();
    },
    onEditOpened(data) {
      console.log("编辑", data);
      this.data.RpIncomeDocDtsDtos = this.data.RpIncomeDocDtsDtos.map((x) => {
        return { ...x, T: null };
      });
      this.data.RpIncomeDocReceiptDtos = this.data.RpIncomeDocReceiptDtos.map(
        (x) => {
          return { ...x, T: null };
        }
      );
      this.$nextTick(() => {
        this.$refs.editList.setData(this.data.RpIncomeDocDtsDtos);
        this.$refs.editList.setIncome(this.Income);
      });
    },
    onOpened() {
      this.settle_api.list({ Status: 1 }).then((res) => {
        if (res.Code == 0) this.Settles = res.Data;
      });
      this.income_api.list({ Status: 1 }).then((res) => {
        if (res.Code == 0) this.Income = res.Data;
      });
    },
    onChange(data) {
      if (data) this.data.NeedTradeUnit = data.NeedTradeUnit;
      else this.data.NeedTradeUnit = true;
      this.$refs.dialog.clearValidate();
    },
    invoiceChange(data) {
      console.log("invoiceChange", data);
      this.data.InvoiceTypeName = data.InvoiceTypeName;
      this.$nextTick(() => {
        this.$refs.editList.setIncome(this.Income, data.DefTaxRate);
      });
    },
    addReceipt() {
      var item = {
        DocReceiptId: 0,
        DocId: this.data.DocId,
        SettleId: null,
        SettleName: "",
        AccountId: null,
        AccountName: "",
        ReceiptAmount: null, //收款金额
        T: 0,
      };
      this.data.RpIncomeDocReceiptDtos.push(item);
    },
    setSettle(row) {
      console.log("setSettle", row);
      var settle = this.Settles.find((x) => x.SettleId == row.SettleId);
      row.AccountId = settle.AccountId;
      row.AccountName = settle.AccountName;
    },
    openEmp() {
      this.$refs.empDialog.open().then((that) => {
        that.getData();
      });
    },
    setEmp(data) {
      this.data.ClerkId = data.EmpId;
      this.data.ClerkName = data.EmpName;
    },
    openAccount(row) {
      this.current = row;
      this.$refs.accountDialog.open().then((that) => {
        that.getData();
      });
    },
    setAccount(data) {
      this.current.AccountId = data.AccountId;
      this.current.AccountName = data.AccountName;
    },
    openTradeunit() {
      this.$refs.tradeunitDialog.open().then((that) => {
        that.getData();
      });
    },
    setTradeunit(data) {
      this.data.TradeUnitId = data.TradeUnitId;
      this.data.TradeUnitName = data.FullName;
    },
    onInput(row) {
      row.T = row.T == 0 ? 0 : 1;
      row.ReceiptAmount = this.$commonJs.obj.toNumber(row.ReceiptAmount);
      var items = this.data.RpIncomeDocReceiptDtos.filter(
        (x) => !!x.ReceiptAmount
      ).map((x) => parseFloat(x.ReceiptAmount));
      var amount = null;
      if (items.length > 0) {
        amount = items.reduce((a, b) => {
          return a + b;
        });
      }
      this.data.ReceiptAmount = amount;
    },
    delReceipt(row, index) {
      if (row.T != 0) this.DelRpIncomeDocReceiptDtos.push({ ...row, T: 2 });
      this.data.RpIncomeDocReceiptDtos.splice(index, 1);
    },
    save(type) {
      this.$refs.dialog.formValidate().then((valid) => {
        if (!valid) return;

        var data = this.$commonJs.obj.removeNullKey(this.data);
        data.RpIncomeDocDtsDtos = this.$refs.editList.Data;
        if (data.RpIncomeDocDtsDtos.length == 0) {
          this.$message.warning("收入信息不能为空");
          return;
        }
        // if (data.RpIncomeDocReceiptDtos.length == 0) {
        //   this.$message.warning("收款信息不能为空");
        //   return;
        // }

        var incomeId = data.RpIncomeDocDtsDtos.every((x) => !!x.IncomeId);
        if (!incomeId) {
          this.$message.warning("收入信息 - 收入名称不能为空");
          return;
        }
        var amount = data.RpIncomeDocDtsDtos.every((x) => !!x.Amount);
        if (!amount) {
          this.$message.warning("收入信息 - 金额不能为空");
          return;
        }
        if (data.InvoiceTypeName != "收据") {
          var taxRate = data.RpIncomeDocDtsDtos.every((x) => !!x.TaxRate);
          if (!taxRate) {
            this.$message.warning("收入信息 - 税率不能为空");
            return;
          }
          // var taxAmount = data.RpIncomeDocDtsDtos.every((x) => !!x.TaxAmount);
          // if (!taxAmount) {
          //   this.$message.warning("收入信息 - 税额不能为空");
          //   return;
          // }
          // var incTaxAmount = data.RpIncomeDocDtsDtos.every(
          //   (x) => !!x.IncTaxAmount
          // );
          // if (!incTaxAmount) {
          //   this.$message.warning("收入信息 - 含税金额不能为空");
          //   return;
          // }
        }

        var settleId = data.RpIncomeDocReceiptDtos.every((x) => !!x.SettleId);
        if (!settleId) {
          this.$message.warning("收款信息 - 结算方式不能为空");
          return;
        }
        var accountId = data.RpIncomeDocReceiptDtos.every((x) => !!x.AccountId);
        if (!accountId) {
          this.$message.warning("收款信息 - 账号不能为空");
          return;
        }
        var receiptAmount = data.RpIncomeDocReceiptDtos.every(
          (x) => !!x.ReceiptAmount
        );
        if (!receiptAmount) {
          this.$message.warning("收款信息 - 收款金额不能为空");
          return;
        }

        var DelRpIncomeDocDtsDtos = this.$refs.editList.DelData;
        data.RpIncomeDocDtsDtos = data.RpIncomeDocDtsDtos.filter(
          (x) => x.T != null
        );
        data.RpIncomeDocDtsDtos.forEach((x) => (x.DocId = this.data.DocId));
        DelRpIncomeDocDtsDtos.forEach((x) => {
          data.RpIncomeDocDtsDtos.push(x);
        });

        data.RpIncomeDocReceiptDtos = data.RpIncomeDocReceiptDtos.filter(
          (x) => x.T != null
        );
        this.DelRpIncomeDocReceiptDtos.forEach((x) => {
          data.RpIncomeDocReceiptDtos.push(x);
        });

        console.log("保存", this.$commonJs.toJson(this.data));

        this.$refs.dialog.isLoading = true;
        this.api[type](data).then((res) => {
          this.$refs.dialog.isLoading = false;
          if (res.Code == 0) {
            this.$message.success(res.Msg);
            this.$emit("close-saved");
            this.close(true);
          } else {
            this.$message.error(res.Msg);
          }
        });
      });
    },
    onClosed() {
      this.DelRpIncomeDocReceiptDtos = [];
      this.data.RpIncomeDocReceiptDtos = [];
    },
  },
};
</script>